// src/config/environment.ts

export const APP_ENV: string = import.meta.env.VITE_APP_ENV || 'production';

export const isStagingEnvironment = (): boolean => {
  return APP_ENV === 'staging';
};

export const isDevelopmentEnvironment = (): boolean => {
  return APP_ENV === 'development' || window.location.hostname === 'localhost';
};

export const isProductionEnvironment = (): boolean => {
  return APP_ENV === 'production';
};

export const shouldShowStagingBanner = (): boolean => {
  return isStagingEnvironment() || isDevelopmentEnvironment(); 
};

export const POSTHOG_KEY = import.meta.env.VITE_POSTHOG_KEY;
export const POSTHOG_HOST = import.meta.env.VITE_POSTHOG_HOST || 'https://app.posthog.com';